import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './UploadIndicator.module.css';

import { useUploadLibFileMutation } from '../../services/library';
import { useInterval } from '../../hooks/useInterval';
import { useAppSelector } from '../../hooks/useRedux';
import { selectLibOptions } from '../../features/librarySlice';

import { UPLOADING } from '../../constants';

export default function UploadIndicator() {
  const cx = classNames.bind(styles);

  const [uploadFile, { status }] = useUploadLibFileMutation({
    fixedCacheKey: 'shared-update-list',
  });
  const [progress, setProgress] = useState(0);

  const { layoutType } = useAppSelector(selectLibOptions);

  if (status === 'fulfilled') {
    setProgress(100);
  }

  useInterval(() => setProgress((prev) => (prev < 90 ? prev + 1 : prev)), 14);
  if (layoutType === 'list') return null;

  return (
    <div className={cx('book_items')}>
      <div className={cx('items_uploading')}>
        <div className={cx('progress_bar')}>
          <div className={cx('progress', 'rail')}></div>
          <div
            className={cx('progress', 'current')}
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <span>{UPLOADING}</span>
      </div>
    </div>
  );
}
